<template>
  <div id="head" class="head">
    <div class="head-left" @click="goBack"><a class="hym-head-left"></a></div>
    <div  class="head-title">{{ vuetiltle }}</div>
     <div class="head-right" v-if="!tuiShow" @click="closeviwe">关闭</div>
      <div class="head-right" v-if="tuiShow" ></div>
  </div>

</template>
<script>
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
//接口地址
import api from "../../api/index";
import tips from "@/estoast";


export default {
  name: "head-back",
  data() {
    return {
      vuetiltle:this.title,
      tuiShow: true
    };
  },
  props: {
    title: String,
    url:String,

  },
  mounted() {
    var appFlag = this.getAppFlag;
    console.log("appFlag:"+appFlag);
    if(appFlag == true){
       this.tuiShow = false;
    }
  },
  methods:{
    closeviwe:function(){
      window.location.href = "hqml://closeWindow";
    },
    goBack:function(){
      if(this.url == '' || this.url == null){
        this.$router.go(-1);
      } else{
        this.$router.push(this.url);
      }
     
    }
  }
};
</script>
<style scoped>

.head{
    left: 0;
    width: 100%;
    height: 88px;
    height: calc(88px + constant(safe-area-inset-top));
    height: calc(88px + env(safe-area-inset-top));
    padding: 7px 3px;
    padding-top: calc(7px + constant(safe-area-inset-top));
    padding-top: calc(7px + env(safe-area-inset-top));
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    overflow: hidden;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    box-sizing: border-box;
    z-index: 998;
    color: #fff;
    background-color: #181723;
    -webkit-transition-property: all;
    transition-property: all;
 }
.head-left{
  position: relative;
  width: 18px;
  height: 32px;
  margin: 30px 0px 28px 32px;
  word-break: keep-all;
  white-space: pre;
  background: url('../../assets/img/head-back@2x.png');
  background-size:100% 100%;

}
.head-left img{
  width: 18;
  height: 32px;
  float: left;
}

.head-title{
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    background:rgba(24,23,35,1);
    margin: 18px 0px 20px 0px;
    width:252px;
    height:50px;
    font-size:36px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(255,255,255,1);
    line-height:50px;

}

.head-right{
    position: relative;
    width: auto;
    margin: 5px 13px 14px 16px;
    word-break: keep-all;
    white-space: pre;
    float: right;
    width:48px;
    height:34px;
    font-size:24px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:34px;
    margin: 22px 32px 32px 0px;


}

</style>



// WEBPACK FOOTER //
// src/components/common/head-back-no-refresh.vue